<div class="container-fluid mt-4">
  <h2 class="mb-3">{{'ADMIN.SETTINGS' | translate}}</h2>

  <!--
    Tabs rather than a screen per setting. The issue tracker configuration was
    its own page and its own admin menu entry, which put two administrative
    settings screens in a menu already fifteen items long.

    destroyOnHide is false so a half-filled tab is not thrown away by clicking
    the other one.
  -->
  <nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
    <ng-container ngbNavItem>
      <a ngbNavLink>{{'ADMIN.TAB_GENERAL' | translate}}</a>
      <ng-template ngbNavContent>

        <form (ngSubmit)="onSubmit()" #serviceForm="ngForm" class="mt-4">

          <div class="mb-4" style="max-width: 640px;">
            <label class="form-label" for="landingPageText">{{'ADMIN.TITLE' | translate}}</label>
            <input type="text" class="form-control" id="landingPageText"
                   [(ngModel)]="admin.landingPageText" name="landingPageText" #landingPageText="ngModel">
            <div class="form-text">{{'ADMIN.TITLE_HELP' | translate}}</div>
          </div>

          <!--
            A fieldset with a legend, not a bare <label>: these are a GROUP of
            checkboxes, and a label element can only name one control. Without
            it a screen reader announces three unrelated tick boxes.
          -->
          <fieldset class="mb-4">
            <legend class="form-label h6 mb-1">{{'ADMIN.LANGUAGES' | translate}}</legend>
            <div class="form-text mb-2">{{'ADMIN.LANGUAGES_HELP' | translate}}</div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="lang-en" checked disabled>
              <label class="form-check-label" for="lang-en">
                {{'ADMIN.LANGUAGE_EN' | translate}}
                <span class="text-muted">— {{'ADMIN.LANGUAGE_REQUIRED' | translate}}</span>
              </label>
            </div>

            @for (code of optionalLanguages; track code) {
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [id]="'lang-' + code"
                       [checked]="isLanguageOffered(code)" (change)="toggleLanguage(code)">
                <label class="form-check-label" [attr.for]="'lang-' + code">
                  {{('ADMIN.LANGUAGE_' + (code | uppercase)) | translate}}
                </label>
              </div>
            }
          </fieldset>

          <!--
            Optional modules. A fieldset, like the languages above, because this
            is a group and will gain entries as more modules become switchable.
          -->
          <fieldset class="mb-4">
            <legend class="form-label h6 mb-1">{{'ADMIN.MODULES' | translate}}</legend>
            <div class="form-text mb-2">{{'ADMIN.MODULES_HELP' | translate}}</div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="module-controls"
                     name="moduleControls" [(ngModel)]="controlsModuleEnabled">
              <label class="form-check-label" for="module-controls">
                {{'ADMIN.MODULE_CONTROLS' | translate}}
              </label>
              <div class="form-text">{{'ADMIN.MODULE_CONTROLS_HELP' | translate}}</div>
            </div>
          </fieldset>

          <button type="submit" class="btn btn-primary" [disabled]="!serviceForm.form.valid">
            {{'ADMIN.SAVE' | translate}}
          </button>
        </form>

      </ng-template>
    </ng-container>

    <ng-container ngbNavItem>
      <a ngbNavLink>{{'ISSUE.SETTINGS.MENU' | translate}}</a>
      <ng-template ngbNavContent>
        <app-issue-tracker-settings></app-issue-tracker-settings>
      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav"></div>
</div>
